module.exports = [{"type":"horizontal","value":16.8594,"section":"A"},{"type":"horizontal","value":38.9178,"section":"B"},{"type":"horizontal","value":60.9762,"section":"C"},{"type":"horizontal","value":83.0346,"section":"E"},{"type":"horizontal","value":96.8229},{"type":"vertical","value":5.9,"section":"1"},{"type":"vertical","value":23.5,"section":"2"},{"type":"vertical","value":41.1,"section":"3"},{"type":"vertical","value":58.7,"section":"4"},{"type":"vertical","value":76.3,"section":"5"},{"type":"vertical","value":94.1}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid-bounds.json
// module id = UjQU
// module chunks = 1